<template>
  <div class="stage-card-info-list-item text-body-2">
    <div class="content mr-2"><slot></slot></div>
    <div class="append"><slot name="append"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'StageCardInfoListItem',
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.stage-card-info-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: map-get($grey, 'darken-2');
}
</style>
